import React from 'react';
import { RELEWISE_DISPLAYED_AT_LOCATION } from '../../integrations/relewise/const';
import { useProductRecommendations } from '../../integrations/relewise/hooks/useProductRecommendations';
import { DisplayedAtLocation } from '../../integrations/relewise/types/mapped';
import { RecommendedProductsCarousel } from '../../shared/components/recommended-products-carousel/recommended-products-carousel';
import { useLazyLoading } from '../../shared/hooks/useLazyLoading';
import {
    displayLocation,
    ICusRecommendedProductsProps,
    recommendationType as RecommendationType
} from './cus-recommended-products.props.autogenerated';

// Necessary to map because MS does not allow spaces in enum values
const DISPLAY_LOCATION_MAPPINGS: Record<displayLocation, DisplayedAtLocation> = {
    [displayLocation.landingPage]: RELEWISE_DISPLAYED_AT_LOCATION.LANDING_PAGE,
    [displayLocation.myAccount]: RELEWISE_DISPLAYED_AT_LOCATION.MY_ACCOUNT
};

const RecommendedProducts = (props: ICusRecommendedProductsProps<never>) => {
    const { context, config, resources } = props;
    const { recommendationType, productCount, relevanceModifier, title, displayLocation, relevanceModifierStrength } = config;

    // Conditional config fields need to be handled defensively in the code,
    // as the CMS does not enforce the condition but just hides the field in the editor
    const categoryRecordId = recommendationType === RecommendationType.recentlyViewed ? undefined : config.categoryRecordId;

    const { ref, isInView } = useLazyLoading();
    const { products, isLoading } = useProductRecommendations({
        productCount,
        recommendationType,
        isEnabled: isInView,
        displayLocation: DISPLAY_LOCATION_MAPPINGS[displayLocation],
        categoryRecordId,
        relevanceModifier,
        relevanceModifierStrength,
        request: context.request,
        telemetry: context.telemetry
    });

    return (
        <RecommendedProductsCarousel
            products={products}
            title={title}
            context={context}
            ctaLabel={resources.recommendedProductsCtaLabel}
            ref={ref}
            isLoading={!isInView || isLoading}
        />
    );
};

export default RecommendedProducts;
